<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Staff Leave Requests'
                    : 'Deleted Leave Requests'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: 120px">
                        Requested by
                      </th>
                      <th class="text-left" style="min-width: 115px">Date</th>
                      <th class="text-left" style="min-width: 96px">
                        Start Time
                      </th>
                      <th class="text-left" style="min-width: 91px">
                        End Time
                      </th>
                      <th class="text-left" style="min-width: 100px">
                        Leave Type
                      </th>
                      <th class="text-left" style="min-width: none">Reason</th>
                      <th class="text-left" style="min-width: none">Replacement</th>
                      <th class="text-left" style="min-width: none">Walks</th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="leave_requests.length != 0">
                    <tr
                      v-for="(leave_request, i) in leave_requests"
                      :key="`leave_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': leave_requests.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="leave_request.status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Request has been approved</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="leave_request.status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="leave_request.status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Request has been rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ leave_request.user.user_name || "" }}
                      </td>
                      <td style="min-width: 115px">
                        {{ leave_request.date || "" }}
                      </td>
                      <td style="min-width: 115px">
                        {{ leave_request.start_time || "" }}
                      </td>
                      <td style="min-width: 115px">
                        {{ leave_request.end_time || "" }}
                      </td>
                      <td style="min-width: 130px">
                        {{ leave_request.leave_type || "" }}
                      </td>
                      <td style="min-width: 255px">
                        <template v-if="leave_request.reason?.length > 85">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  leave_request.reason?.length > 85
                                    ? leave_request.reason.slice(0, 85) + "..."
                                    : leave_request.reason
                                }}
                              </span>
                            </template>
                            <span>{{ leave_request.reason }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ leave_request.reason }}
                        </template>
                      </td>
                      <td>
                        <template v-if="leave_request.replacement_user_id">
                          <v-chip
                            color="primary"
                            text-color="white"
                            small
                          >
                            <v-avatar left>
                              <v-icon small>mdi-account-switch</v-icon>
                            </v-avatar>
                            {{ leave_request.replacement_user?.first_name }} {{ leave_request.replacement_user?.last_name }}
                          </v-chip>
                        </template>
                        <template v-else-if="leave_request.status === 1">
                          <v-chip
                            color="warning"
                            text-color="white"
                            small
                          >
                            No replacement assigned
                          </v-chip>
                        </template>
                        <template v-else>
                          -
                        </template>
                      </td>
                      <td style="min-width: 600px">
                        <template v-if="leave_request.walks.length">
                          <v-expansion-panels class="my-2" flat>
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                color="primary lighten-1"
                                class="white--text"
                              >
                                <div>
                                  <v-icon small color="white" class="mr-2">mdi-walk</v-icon>
                                  List of Walks ({{ leave_request.walks.length }})
                                </div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-simple-table
                                  fixed-header
                                  class="striped-table"
                                >
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th style="width: 100">Date</th>
                                        <th style="width: 100">Timeslot</th>
                                        <th style="width: 120">Pet Owner</th>
                                        <th style="width: 100">Pet Name</th>
                                        <th style="width: 80">Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          walk, dcrR
                                        ) in leave_request.walks"
                                        :key="`detail_${dcrR}`"
                                        :class="{
                                          'table-row-even': dcrR % 2 === 0,
                                          'table-row-odd': dcrR % 2 !== 0,
                                          'table-row-last':
                                            leave_request.walks.length - 1 == dcrR,
                                        }"
                                      >
                                        <td style="min-width:105px;">{{ walk.daily_job_plan?.date || '-' }}</td>
                                        <td>{{ walk.timeslot || '-' }}</td>
                                        <td>
                                          <template v-if="walk.daily_job_plan?.user">
                                            {{ walk.daily_job_plan.user.first_name }} {{ walk.daily_job_plan.user.last_name }}
                                          </template>
                                          <template v-else>-</template>
                                        </td>
                                        <td>
                                          <template v-if="walk.daily_job_plan?.user_pet">
                                            {{ walk.daily_job_plan.user_pet.name }}
                                          </template>
                                          <template v-else>-</template>
                                        </td>
                                        <td>
                                          <v-chip
                                            :color="getWalkStatusColor(walk.status)"
                                            text-color="white"
                                            x-small
                                          >
                                            {{ getWalkStatusText(walk.status) }}
                                          </v-chip>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </template>
                        <template v-else> </template>
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(leave_request.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 155px">
                        <v-btn
                          v-if="leave_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="success"
                          @click="openReplacementModal(leave_request)"
                        >
                          <v-icon dark>mdi-check</v-icon>
                        </v-btn>
                        <!-- Reject button (only show if status is 0) -->
                        <v-btn v-can:edit="'leave_requests'"
                          v-if="leave_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="error"
                          @click="updateStatus(leave_request.id, 2)"
                        >
                          <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'leave_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="OpenWarning(leave_request.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Request</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'leave_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(leave_request.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this leave_request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'leave_requests'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Full Day Reassign Warning Dialog Box -->
      <v-dialog v-model="reassign_full_day_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">FULL DAY REASSIGN</h1>
                      <br />
                      <h3>Reassign All the </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'leave_requests'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!--Time Based Reassign Warning Dialog Box -->
      <v-dialog v-model="reassign_walk_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">WALK REASSIGN</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'leave_requests'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_leave_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Request deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_leave_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_leave_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>LeaveRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_leave_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Staff Replacement Modal -->
      <staff-replacement-modal
        v-model="showReplacementModal"
        :leave-request="selectedLeaveRequest"
        @approved="onLeaveApproved"
        @cancelled="onModalCancelled"
      />
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import StaffReplacementModal from '@/components/StaffReplacementModal.vue';

export default {
  name: "LeaveRequestsPage",
  components: {
    StaffReplacementModal
  },
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      leave_requests: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportLeaveRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      reassign_full_day_popUp: false,
      reassign_walk_popUp: false,
      isLoading: false,
      isExcelloading: false,
      delete_leave_request: false,
      is_deleted_leave_request: false,
      restore_leave_request: false,
      is_restored_leave_request: false,
      show_Warning_popUp: false,
      pendingRequestId: "",
      is_confirmed_delete: "",
      to_be_deleted_id: "",
      deleteDialog: "",
      selected_requested: {},
      showReplacementModal: false,
      selectedLeaveRequest: {}
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    getWalkStatusColor(status) {
      switch (status) {
        case 0: return 'grey';        // Pending
        case 1: return 'warning';      // Started
        case 2: return 'success';      // Completed
        case 3: return 'warning';        // Reschedule Pending
        case 4: return 'green';        // Reschedule Approved
        case 5: return 'error';        // Reschedule Rejected
        default: return 'grey';
      }
    },
    getWalkStatusText(status) {
      switch (status) {
        case 0: return 'Pending';
        case 1: return 'Started';
        case 2: return 'Completed';
        case 3: return 'Reschedule Pending';
        case 4: return 'Reschedule Approved';
        case 5: return 'Reschedule Rejected';
        default: return 'Unknown';
      }
    },
    OpenReassignFullDayPopUp(request) {
      this.selected_requested = request;
      this.reassign_full_day_popUp = true;
    },
    OpenReassignWalkPopUp(request) {
      this.selected_requested = request;
      this.reassign_walk_popUp = true;
    },
    OpenWarning(request_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
        leave_type: this.leave_requests.find((request) => request.id === id)
          .leave_type,
      };
      this.show_Warning_popUp = true;
    },
    async confirmUpdate(selected_requested) {
      console.log("Confirm Update", selected_requested);
      let reqID = this.encryptIt(selected_requested.id);

      await axios
        .patch(`/leave_requests/${reqID}`, selected_requested)
        .then(() => {
          this.getData();
        });
      this.show_Warning_popUp = false;
      if (selected_requested.status === 1) {
        console.log("Approve Request");
        if (selected_requested.leave_type === "full_day") {
          console.log("Full Day Reassign");
          this.OpenReassignFullDayPopUp(selected_requested);
        } else if (selected_requested.leave_type === "time_range") {
          console.log("walk Reassign");
          this.OpenReassignWalkPopUp(selected_requested);
        }
      }else{
        console.log("Reject Request");
        
      }
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`leave_requests?${query}`)
        .then((response) => {
          this.leave_requests = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`leave_request_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_leave_request = true;
      await axios
        .post(`/leave_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_leave_request = false;
          this.is_deleted_leave_request = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_leave_request = true;
      await axios
        .post(`/leave_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_leave_request = false;
          this.is_restored_leave_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
    openReplacementModal(leaveRequest) {
      this.selectedLeaveRequest = leaveRequest;
      this.showReplacementModal = true;
    },
    onLeaveApproved(updatedLeaveRequest) {
      // Update the leave request in the list
      const index = this.leave_requests.findIndex(lr => lr.id === updatedLeaveRequest.id);
      if (index !== -1) {
        this.leave_requests[index] = updatedLeaveRequest;
      }
      this.showReplacementModal = false;
      this.selectedLeaveRequest = {};
      // Optionally refresh the data
      this.getData();
    },
    onModalCancelled() {
      this.showReplacementModal = false;
      this.selectedLeaveRequest = {};
    },
  },
};
</script>
